import styled from 'styled-components';

export const Board = styled.div<{ boardHeight?: number }>`
  height: ${(props) => (props.boardHeight ? `${props.boardHeight}px` : 'auto')};
`;
